// EosManager/recommendations.ts
// Note: keep this file free of React/UI. Decision logic only.

export type ClinicalCondition = "Well Appearing" | "Equivocal" | "Clinical Illness";

export type Recommendation =
  | "ROUTINE_VITALS"
  | "VITALS_EVERY_4_HOURS"
  | "BLOOD_CULTURE_VITALS_EVERY_4_HOURS"
  | "ANTIBIOTICS_VITALS_PER_NICU";

type EosPerClinicalCondition = Record<string, string | number>;

function toNumber(value: string | number | undefined): number {
  if (value === undefined) return NaN;
  const n = typeof value === "number" ? value : parseFloat(value);
  return n;
}

export function getRecommendation(params: {
  clinicalCondition: ClinicalCondition;
  eosPerClinicalCondition: EosPerClinicalCondition;
  eos: number;
  temperature?: number;
  minTemperatureBeforeForcingAntibiotics: number;
}): Recommendation {
  const {
    clinicalCondition,
    eosPerClinicalCondition,
    eos,
    temperature,
    minTemperatureBeforeForcingAntibiotics,
  } = params;

  // Force antibiotics if maternal temp is high enough
  if ((temperature ?? 0) >= minTemperatureBeforeForcingAntibiotics) {
    return "ANTIBIOTICS_VITALS_PER_NICU";
  }

  if (clinicalCondition === "Clinical Illness") {
    return "ANTIBIOTICS_VITALS_PER_NICU";
  }

  const riskPerCondition = toNumber(eosPerClinicalCondition[clinicalCondition]);

  if (riskPerCondition < 1) {
    return eos * 1000 < 1 ? "ROUTINE_VITALS" : "VITALS_EVERY_4_HOURS";
  }

  if (riskPerCondition >= 1 && riskPerCondition < 3) {
    return "BLOOD_CULTURE_VITALS_EVERY_4_HOURS";
  }

  return "ANTIBIOTICS_VITALS_PER_NICU";
}